// Colour-scheme selection. Each theme is a set of CSS-token overrides keyed off
// html[data-theme="<id>"] (see src/index.css). The choice persists in
// localStorage; public/theme-boot.js applies it before first paint so there is
// no flash of the default teal.

export const THEME_KEY = 'sid2midi.theme';

export const THEMES = [
  { id: 'teal', label: 'Teal (default)' },
  { id: 'c64', label: 'C64 Blue' },
  { id: 'mono-bright', label: 'Monochrome Bright' },
  { id: 'mono-dark', label: 'Monochrome Dark' },
  { id: 'green', label: 'Green Phosphor' },
  { id: 'amber', label: 'Amber Phosphor' },
] as const;

export type ThemeId = (typeof THEMES)[number]['id'];

const VALID = new Set<string>(THEMES.map((t) => t.id));

export function getTheme(): ThemeId {
  try {
    const v = localStorage.getItem(THEME_KEY);
    return v && VALID.has(v) ? (v as ThemeId) : 'teal';
  } catch {
    return 'teal';
  }
}

export function applyTheme(id: ThemeId) {
  document.documentElement.setAttribute('data-theme', id);
}

export function setTheme(id: ThemeId) {
  try {
    localStorage.setItem(THEME_KEY, id);
  } catch {
    /* storage may be unavailable */
  }
  applyTheme(id);
}

/** Reads a theme token's current value (for canvas drawing). */
export function token(name: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(`--${name}`).trim();
}
